import { writable } from 'svelte/store';

function createMyStore() {
    const { subscribe, set, update } = writable({});

    return {
        subscribe, update, set,
        clear: () => {
            set(n => new {})
        }
    };
}
export const outputVariableStore = createMyStore();